import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, isPhone, isEmail, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "company";
const modulePath = "/owner";
const moduleName = "Client";
const moduleID = 2;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        company_name: "",
        contact_person: "",
        address: "",
        phone: "",
        email: "",
        management: "",
        rpsl: false,
        companyStatus: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const companyStatus = result.companyStatus === "A" ? "Active" : "In Active";
          const status =
            result.companyStatus !== "" && result.companyStatus !== null
              ? {
                  label: companyStatus,
                  value: result.companyStatus,
                }
              : "";
          const management = result?.management ?? "";
          const rpsl = result?.rpsl ?? "No";
          const clientupdatedata = {
            company_name: result.company_name,
            contact_person: result.contact_person,
            address: result.address,
            phone: result.phone,
            email: result.email,
            management: management !== null && management !== "" ? { label: management, value: management } : "",
            rpsl: rpsl === "Yes" ? true : false,
            companyStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      company_name: postData.company_name.toUpperCase(),
      contact_person: postData.contact_person.toUpperCase(),
      address: postData.address.toUpperCase(),
      phone: postData.phone,
      email: postData.email,
      management: postData.management?.value ?? "",
      rpsl: postData.rpsl === true ? "Yes" : "No",
      companyStatus: postData.companyStatus?.value ?? "I",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props}  />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { company_name, contact_person, address, phone, email, management, companyStatus } = props.fields;

  return {
    fields: ["company_name", "contact_person", "address", "phone", "email", "management", "companyStatus"],
    validations: {
      company_name: [[isEmpty, company_name]],
      contact_person: [[isEmpty, contact_person]],
      address: [[isEmpty, address]],
      phone: [
        [isEmpty, phone],
        [isPhone, phone],
      ],
      email: [
        [isEmpty, email],
        [isEmail, email],
      ],
      management: [[isSingleSelect, management]],
      companyStatus: [[isSingleSelect, companyStatus]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgcompany_name,
      errMsgcontact_person,
      errMsgaddress,
      errMsgphone,
      errMsgemail,
      errMsgmanagement,
      errMsgStatus = "";
    if ($validation.company_name.error.reason !== undefined) {
      errMsgcompany_name = $validation.company_name.show && <span className="error">{$validation.company_name.error.reason}</span>;
    }
    if ($validation.contact_person.error.reason !== undefined) {
      errMsgcontact_person = $validation.contact_person.show && <span className="error">{$validation.contact_person.error.reason}</span>;
    }
    if ($validation.address.error.reason !== undefined) {
      errMsgaddress = $validation.address.show && <span className="error">{$validation.address.error.reason}</span>;
    }

    if ($validation.phone.error.reason !== undefined) {
      errMsgphone = $validation.phone.show && <span className="error">{$validation.phone.error.reason}</span>;
    }
    if ($validation.email.error.reason !== undefined) {
      errMsgemail = $validation.email.show && <span className="error">{$validation.email.error.reason}</span>;
    }
    if ($validation.management.error.reason !== undefined) {
      errMsgmanagement = $validation.management.show && <span className="error">{$validation.management.error.reason}</span>;
    }

    if ($validation.companyStatus.error.reason !== undefined) {
      errMsgStatus = $validation.companyStatus.show && <span className="error">{$validation.companyStatus.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Company Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Company Name"
                name="company_name"
                value={fields.company_name}
                {...$field("company_name", (e) => onChange("company_name", e.target.value))}
              />
              {errMsgcompany_name}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Contact Person<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Contact Person"
                name="contact_person"
                value={fields.contact_person}
                {...$field("contact_person", (e) => onChange("contact_person", e.target.value))}
              />
              {errMsgcontact_person}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="Address" name="address" value={fields.address} {...$field("address", (e) => onChange("address", e.target.value))} />
              {errMsgaddress}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Phone Number<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Phone Number" name="phone" value={fields.phone} {...$field("phone", (e) => onChange("phone", e.target.value))} />
              {errMsgphone}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Email<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Email" name="email" value={fields.email} {...$field("email", (e) => onChange("email", e.target.value))} />
              {errMsgemail}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Management Type<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.management}
                onChange={this.handleSelectChange.bind(this, "management")}
                placeholder="Select Management Type"
                isClearable={true}
                options={[
                  { value: "Owners", label: "Owners" },
                  { value: "Managers", label: "Managers" },
                ]}
              />
              {errMsgmanagement}
            </div>
            <div className="form-group col-md-2">
              <div class="custom-controls-stacked mt-6 mx-5">
                <label class="custom-control custom-checkbox-md">
                  <input type="checkbox" class="custom-control-input" name="example-checkbox5" value="option5" checked={fields.rpsl} onChange={this.handlecheckedChange.bind(this, "rpsl")} />
                  <span class="custom-control-label">RPSL</span>
                </label>
              </div>
            </div>

            <div className="form-group col-md-2">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.companyStatus}
                onChange={this.handleSelectChange.bind(this, "companyStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
